import request from '@/utils/request'
import {
  CONFIG
} from "../base";
/**
 * 全局-字典-分类
 * */

//获取字典分类树
export function getGlobalDictClassTree() {
  return request({
    url: CONFIG + '/globalDictClass/getTree',
    method: 'post'
  })
}
//添加字典分类
export function addGlobalDictClass(data) {
  return request({
    url: CONFIG + '/globalDictClass/add',
    method: 'post',
    data: data
  })
}
//删除字典分类
export function delGlobalDictClass(query) {
  return request({
    url: CONFIG + '/globalDictClass/delete',
    method: 'post',
    params: {
      id: query
    }
  })
}
//编辑字典分类
export function updateGlobalDictClass(data) {
  return request({
    url: CONFIG + '/globalDictClass/update',
    method: 'post',
    data: data
  })
}

/**
 * 全局-字典-数据
 * */

//查询字典数据
export function getdictItem(query) {
  return request({
    url: CONFIG + '/SearchDictItem/queryItem',
    method: 'get',
    params: {
      dictClassCode:query,
    },
    headers:{
      _extend_config:{
        loading:{
          showLoading:false
        }
      }
    }
  })
}
export async function getdictItems(query) {
  return await asyncGetdictItems(query)
}

function asyncGetdictItems(query){
  return request({
    url: CONFIG + '/SearchDictItem/queryItem',
    method: 'get',
    async: false,
    params: {
      dictClassCode:query.dictClassCode,
      dictItemCode:query.dictItemCode,
    },
    headers:{
      _extend_config:{
        loading:{
          showLoading:false
        }
      }
    }
  })
}

//查询字段数据树-根
export function getGlobalDictItemTreeRoot(data) {
  return request({
    url: CONFIG + '/globalDictItem/queryTreeRoot',
    method: 'post',
    params: {
      dictClassId: data
    }
  })
}
//查询字典数据列表
export function queryGlobalDictItemList(data) {
  return request({
    url: CONFIG + '/globalDictItem/queryList',
    method: 'post',
    params: data
  })
}
//添加字典数据
export function addGlobalDictItem(data) {
  return request({
    url: CONFIG + '/globalDictItem/add',
    method: 'post',
    data: data
  })
}
//删除字典数据
export function delGlobalDictItem(query) {
  return request({
    url: CONFIG + '/globalDictItem/delete',
    method: 'post',
    params: {
      id: query
    }
  })
}
//修改字典数据
export function updateGlobalDictItem(data) {
  return request({
    url: CONFIG + '/globalDictItem/update',
    method: 'post',
    data: data
  })
}



//全局-根据字典分类CODE和字典数据CODE查询对应字典数据

export function getGlobalDictItemByCode(queryData) {
  return request({
    url: CONFIG + '/SearchDictItem/getItem',
    method: 'get',
    params: {
      dictClassCode:queryData.dictClassCode,
      dictItemCode:queryData.dictItemCode,
      dictItemParentCode:queryData.dictItemParentCode
    }
  })
}

/**
 * 租户-字典-分类
 * */
//获取字典分类树
export function getTenantDictClassTree() {
  return request({
    url: CONFIG + '/tenantDictClass/getTree',
    method: 'post'
  })
}
//添加字典分类
export function addTenantDictClass(data) {
  return request({
    url: CONFIG + '/tenantDictClass/add',
    method: 'post',
    data: data
  })
}
//删除字典分类
export function delTenantDictClass(query) {
  return request({
    url: CONFIG + '/tenantDictClass/delete',
    method: 'post',
    params: {
      id: query
    }
  })
}
//编辑字典分类
export function updateTenantDictClass(data) {
  return request({
    url: CONFIG + '/tenantDictClass/update',
    method: 'post',
    data: data
  })
}


/**
 * 租户-字典-数据
 * */
//查询字典数据
export async function getTenantDictItem(queryData) {
  return await asyncGetTenantDictItem(queryData)
}

function asyncGetTenantDictItem(queryData){
  return request({
    url: CONFIG + '/SearchDictItem/queryItem',
    method: 'get',
    async:false,
    params: {
      dictClassCode:queryData.dictClassCode,
      dictItemCode:queryData.dictItemCode
    }
  })
}


//查询字段数据树-根
export function getTenantDictItemTreeRoot(data) {
  return request({
    url: CONFIG + '/tenantDictItem/queryTreeRoot',
    method: 'post',
    params: {
      dictClassId: data
    }
  })
}
//查询字典数据列表
export function queryTenantDictItemList(data) {
  return request({
    url: CONFIG + '/tenantDictItem/queryList',
    method: 'post',
    params: data
  })
}
//添加字典数据
export function addTenantDictItem(data) {
  return request({
    url: CONFIG + '/tenantDictItem/add',
    method: 'post',
    data: data
  })
}
//删除字典数据
export function delTenantDictItem(query) {
  return request({
    url: CONFIG + '/tenantDictItem/delete',
    method: 'post',
    params: {
      id: query
    }
  })
}
//修改字典数据
export function updateTenantDictItem(data) {
  return request({
    url: CONFIG + '/tenantDictItem/update',
    method: 'post',
    data: data
  })
}


//租户-根据字典分类CODE和字典数据CODE查询对应字典数据

export function getTenantDictItemByCode(queryData) {
  return request({
    url: CONFIG + '/SearchDictItem/getItem',
    method: 'get',
    params: {
      dictClassCode:queryData.dictClassCode,
      dictItemCode:queryData.dictItemCode,
      dictItemParentCode:queryData.dictItemParentCode
    }
  })
}




// WEBPACK FOOTER //
// ./src/api/config/dict.js